import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const InfoSection = ({ shoppingCenters, extrastockType }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Unità')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('MQ')} name='square'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Tipologia Stock')} name='extrastock_type'>
          <Select placeholder={t('Selezioni opzione')}>
            <Option value={''}>{t('Selezioni opzione')}</Option>
            {extrastockType.map((i) => (
              <Option key={i.value} value={i.value}>
                {i.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Option value={''}>{t('Selezioni opzione')}</Option>
            {shoppingCenters.map((i) => (
              <Option key={i.id} value={i.id}>
                {i.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item
          label={t('Listino canone d’affitto (€/mese)')}
          name='rent_price'
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Listino utenze (€/mese)')}
          name='consumption_price'
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Note')} name='comments'>
          <Input.TextArea placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
